import { MaskInput } from 'maska'

let masks = []

function setupPhoneInputs(container) {
  ;(container || document).querySelectorAll('input[type="tel"], input[type="text"][inputmode="tel"]').forEach(
    /**
     * @param {HTMLInputElement} input
     */
    (input) => {
      const mask = new MaskInput(input, {
        mask: '###-###-####',
      })
      masks.push(mask)
    },
  )
}

function teardownPhoneInputs() {
  masks.forEach((mask) => mask.destroy())
  masks = []
}

export { setupPhoneInputs, teardownPhoneInputs }
